import { ReactNode } from 'react'
import { useTranslate } from 'react-admin'

interface SettingsCrumb {
  label: ReactNode
  to?: string
}

/**
 * Breadcrumbs of a settings page: Instellingen > list > current.
 * The list links back once `current` is given; `null` links without a third crumb.
 */
export const useSettingsCrumbs = (resource: 'municipality' | 'organization', current?: ReactNode): SettingsCrumb[] => {
  const translate = useTranslate()
  return [
    { label: translate('submenu.settings') },
    { label: translate(`resources.${resource}.list`), ...(current !== undefined && { to: `/${resource}` }) },
    ...(current ? [{ label: current }] : []),
  ]
}
